export interface SyncSummary {
  fetched: number;
  upcoming: number;
  created: number;
  updated: number;
}

// Admin: run the server-side LoL Esports -> Firestore sync now.
export async function syncMatches(idToken: string, backfill = false): Promise<SyncSummary> {
  const res = await fetch(`/api/sync-matches${backfill ? "?backfill=1" : ""}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${idToken}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Không thể đồng bộ lịch thi đấu");
  return data;
}

// Visitors: nudge the throttled server sync (at most once per 10 minutes
// across all visitors). Fire-and-forget; failures are irrelevant to the UI.
export function pingMatchSync(): void {
  fetch("/api/sync-matches").catch(() => {});
}
